import { MobileView } from "react-device-detect";
import SidebarMobileView from "./SideparMobileView";
import "./Sidebar.css";

const Sidebar = ({
  open,
  setOpen,
  checked,
  setChecked,
  btnClickOne,
  btnClickTwo,
  reductionStateOne,
  reductionStateTwo,
  setWithAdaptations,
  withAdaptations,
}) => {
  return (
    <>
      <MobileView>
        <SidebarMobileView
          open={open}
          setOpen={setOpen}
          checked={checked}
          setChecked={setChecked}
          btnClickOne={btnClickOne}
          btnClickTwo={btnClickTwo}
          reductionStateOne={reductionStateOne}
          reductionStateTwo={reductionStateTwo}
          withAdaptations={withAdaptations}
          setWithAdaptations={setWithAdaptations}
        />
      </MobileView>
    </>
  );
};

export default Sidebar;
